export default __webpack_public_path__ + "static/media/google.13404aa7.svg";